import { twMerge } from 'tailwind-merge';
import Card from '@/components/Card';
import TabsBlock, { Tab, type TabChild } from '@/components/TabsBlock';
import { ArrowRightIcon } from '@/icons';
import { classes } from './utils';

export { Tab as OverviewTab };

export interface OverviewCardProps {
  className?: string;
  title: string;
  subtitle?: string | null;
  name: string;
  defaultTab?: string;
  viewAllLabel?: string;
  onTabChange?: (tabName: string) => void;
  onViewAll?: () => void;
  children: TabChild[];
}

export default function OverviewCard({
  className,
  title,
  subtitle,
  name,
  defaultTab,
  viewAllLabel = 'View all',
  onTabChange,
  onViewAll,
  children,
}: OverviewCardProps) {
  return (
    <Card className={twMerge(classes.panel, className)}>
      <div className={classes.header}>
        <div className={classes.titleWrapper}>
          <h2 className={classes.title}>{title}</h2>
          {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
        </div>
        {onViewAll && (
          <button className={classes.viewAll} onClick={onViewAll}>
            {viewAllLabel}
            <ArrowRightIcon className={classes.viewAllIcon} />
          </button>
        )}
      </div>
      <TabsBlock
        name={name}
        labelClassName={classes.tabs}
        defaultTab={defaultTab}
        onChange={onTabChange}>
        {children}
      </TabsBlock>
    </Card>
  );
}
